import React, {Suspense} from 'react';
import {Loader} from "./Loader";

export function LazyLoader({Component, ...rest}) {
    return <Suspense fallback={Loader}>
        <Component {...rest}/>
    </Suspense>
}
